import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    templateUrl: './home.html',
    styleUrls: ['./home.scss']
})
export class HomeComponent {   
    public constructor(
       
    ){

    }
}


// WEBPACK FOOTER //
// ./src/app/pages/home/home.ts